
<template>
  <div>
    <employee-list></employee-list>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'PageEmployeeList',
  components: {
    EmployeeList: () => import('@/_backoffice/_registrations/components/employee/IndexEmployee.vue'),
  },
}
</script>
